module.exports = __webpack_public_path__ + "img/user-secret-solid.d763a361.svg";